import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import { AdminSearch } from 'app/components/AdminSearchField';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { PageMainLabel } from 'app/components/SHLabel';
import React, { useEffect, useState } from 'react';
import { useDebounce } from 'hooks/useDebounce';
import { usePermission } from 'hooks/usePermission';
import { GeneralLookup } from 'services/openapi';
import ApproveRiderTable from './approveRiderTable';
import useCoachApi from 'admin/hooks/useCoachApi';
import AdminDropDown from 'app/components/AdminDropDown';
import styled from 'styled-components';

export interface BreadCrumbDataModel {
    id: string;
    text?: string;
}
const pageSizeOptions: GeneralLookup[] = [
    { id: '25', name: '25' },
    { id: '50', name: '50' },
    { id: '100', name: '100' },
    { id: '200', name: '200' },
];
const ApproveRiderPage = () => {
    const breadCrumbItems = [
        {
            id: '',
            text: 'Showyeda coach',
            disabled: true,
        },
        {
            id: '',
            text: 'Pending Riders',
            disabled: true,
        },
    ];

    const {
        fetchApprovalPendingRiders,
        approvePendingRider,
        pendingRidersData,
        loading,
    } = useCoachApi();

    const [searchTerm, setSearchTerm] = useState<string>('');
    const [pageSkip, setPageSkip] = useState<number | undefined>(0);
    const debounceSearchTerm = useDebounce(searchTerm);
    const [breadcrumbPreData, setBreadcrumbPreData] =
        React.useState<BreadCrumbDataModel[]>(breadCrumbItems);

    const [pageSize, setPageSize] = useState<number>(50);
    const [pageSizeSelected, setPageSizeSelected] = useState<GeneralLookup>({
        id: '50',
        name: '50',
    });

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
        setPageSkip(0); // Reset to first page on new search
    };

    // Fetch pending riders on component mount and when search/pagination changes
    useEffect(() => {
        fetchApprovalPendingRiders(debounceSearchTerm, pageSkip, pageSize);
    }, [debounceSearchTerm, pageSkip, pageSize]);

    return (
        <>
            <CommonPageWrapper>
                <HeadingWrapper>
                    <PageMainLabel>Pending Riders Approval</PageMainLabel>
                    <CustomBreadCrumb
                        preData={breadcrumbPreData}
                        setPreData={setBreadcrumbPreData}
                    />
                </HeadingWrapper>

                <HeadingWrapper>
                    <div style={{ width: '283px', paddingTop: '30px' }}>
                        <AdminSearch
                            placeholder="Search by rider name or email"
                            onSearchTextEntering={handleSearch}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                        />
                    </div>
                </HeadingWrapper>
                {(pendingRidersData?.pageDetails?.count ?? 0) > 25 && (
                    <EntriesPerPageDropDownWrapper>
                        <AdminDropDown
                            label="No: of entries per page"
                            placeholder="Select entries"
                            onDataChange={(data: GeneralLookup) => {
                                const newPageSize = parseInt(data.id, 10);
                                setPageSize(newPageSize);
                                setPageSizeSelected(data);
                                setPageSkip(0);
                                fetchApprovalPendingRiders(debounceSearchTerm, 0, pageSize);
                            }}
                            defaultValue={pageSizeSelected}
                            data={pageSizeOptions}
                            className="entries-dropdown-style"
                            popupStyles="entries-dropdown-popup"
                        />
                    </EntriesPerPageDropDownWrapper>
                )}
                {/* Pending Riders Table */}
                <ApproveRiderTable
                    pendingRidersData={pendingRidersData}
                    setPageSkip={setPageSkip}
                    pageSkip={pageSkip}
                    fetchPendingRiders={fetchApprovalPendingRiders}
                    approvePendingRider={approvePendingRider}
                    debounceSearchTerm={debounceSearchTerm}
                    loading={loading}
                    pageSize={pageSize}
                    pageSizeSelected={pageSizeSelected}
                />
            </CommonPageWrapper>
        </>
    );
};

export default ApproveRiderPage;

const EntriesPerPageDropDownWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding-top: 10px;
  .SHdropdown {
    width: 160px;

    .label {
      margin-bottom: 8px;
      font-size: 13px;
      color: #475467;
      font-weight: 500;
    }

    .k-dropdownlist {
      max-height: 38px;
      border-radius: 8px !important;
    }

    .k-input-inner {
      padding: 0 8px !important;
      font-size: 13px;
    }

    .k-input-value-text {
      margin: 4px 0;
      font-size: 13px !important;
      color: #1e1e1e;
    }
  }
`;